module.exports = __webpack_public_path__ + "img/floatExplain.93854d36.svg";